import React from 'react'
import ViewLayout from 'components/viewLayout/desktop'
import backgroundImg from 'image/object.png'
import MainContent from 'views/article/common/mainContent'

function Article() {
  return (
    <ViewLayout
      backgroundImg={backgroundImg}
      customizedStyles={{ contentMarginTop: '12rem' }}
    >
      {MainContent()}
    </ViewLayout>
  )
}

export default Article
